export const getValueFromInfoObject = (key, obj, objTitle) => {
    let value = null;
    if (objTitle in obj){
        if (key in obj[objTitle]){
            value = obj[objTitle][key]
        }
    }

    return value
}